module.exports = __webpack_public_path__ + "static/media/person_selected.ab439829.svg";